import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
    title: string;
}

function LinkContainer({ children, title }:Props) {
    return (
        <Container spacing={8} fullWidth>
            <Text color={colors.gray7} size='s' fontWeight='bold'>{title}</Text>
            <Grid>
                {children}
            </Grid>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 16px 0;
    width: calc(100% - 32px);
    margin: 0 16px;
    border-bottom: 1px solid ${colors.gray2};
    &:nth-last-of-type(1) {
        border: none;
    }
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
`;

export default LinkContainer;
